import { render, staticRenderFns } from "./guide-api.vue?vue&type=template&id=74b04517&scoped=true"
import script from "./guide-api.vue?vue&type=script&lang=ts"
export * from "./guide-api.vue?vue&type=script&lang=ts"
import style0 from "./guide-api.vue?vue&type=style&index=0&id=74b04517&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74b04517",
  null
  
)

export default component.exports